import { Loader } from 'UI/elements';
import styles from './LoadingPage.module.scss';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

export function LoadingPage(): React.ReactElement {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    return () => {
      setIsExiting(true);
    };
  }, []);

  return (
    <div className={classNames(styles.loadingPage, isExiting && styles.exiting)}>
      <Loader size={100} tintColor="#080D0D" backgroundColor="#ffffff" />
    </div>
  );
}
